import TextEllipsize from 'utils/TextEllipsize';
import PropTypes from 'prop-types';

const ShowDataWithSpaces = ({ value }) => {
  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      <TextEllipsize value={value} />
    </div>
  );
};

ShowDataWithSpaces.propTypes = {
  value: PropTypes.string
};

export default ShowDataWithSpaces;
